import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { INACTIVITY_LIMIT } from "../../common/constants";

const InactivityHandler = () => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Set inactivity timer
  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsDialogOpen(true);
    }, INACTIVITY_LIMIT);
  }, []);

  const handleUserActivity = useCallback(() => {
    if (!isDialogOpen) {
      resetTimer();
    }
  }, [resetTimer, isDialogOpen]);

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, handleUserActivity));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, handleUserActivity));
    };
  }, [handleUserActivity, resetTimer]);

  const handleRefresh = () => {
    window.location.reload();
  };
  const handleDialogClose = () => {
    setIsDialogOpen(false);
    resetTimer();
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={(_, data) => setIsDialogOpen(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<Dismiss20Regular />}
                onClick={handleDialogClose}
                aria-label="Close"
              />
            }
          >
            Are you still there?
          </DialogTitle>
          <p className="refresh-page-title">Refresh the page for the latest updates.</p>
          <DialogActions>
            <Button appearance="primary" onClick={handleRefresh}>
              Refresh
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default InactivityHandler;
